import { render } from "./AddEnum.vue?vue&type=template&id=a5770fb6"
import script from "./AddEnum.vue?vue&type=script&lang=js"
export * from "./AddEnum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__